import { parse } from 'iso8601-duration';
import { formatDuration } from 'date-fns';
export const getTabs = ({ products, subscriptions, rentals, }) => {
    const tabs = [];
    products?.length > 0 && tabs.push({
        title: 'Buy',
        purchasables: products,
    });
    if (subscriptions?.length > 0) {
        const groups = subscriptions.reduce((acc, sub) => {
            if (!sub.period) {
                acc['Subscribe']
                    ? acc['Subscribe'].push(sub)
                    : acc['Subscribe'] = [sub];
            }
            else {
                const parsed = parse(sub.period);
                let mappedPeriod = formatDuration(parsed);
                if (mappedPeriod === '1 year') {
                    mappedPeriod = 'Yearly';
                }
                else if (mappedPeriod === '1 month') {
                    mappedPeriod = 'Monthly';
                }
                else if (mappedPeriod === '1 week') {
                    mappedPeriod = 'Weekly';
                }
                if (acc[mappedPeriod]) {
                    acc[mappedPeriod].push(sub);
                }
                else {
                    acc[mappedPeriod] = [sub];
                }
            }
            return acc;
        }, {});
        Object.keys(groups).forEach((key) => {
            tabs.push({
                title: key,
                purchasables: groups[key],
            });
        });
    }
    rentals?.length > 0 && tabs.push({
        title: 'Rent',
        purchasables: rentals,
    });
    return tabs;
};
//# sourceMappingURL=getTabs.js.map